import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchInteriorComponent } from './search-interior.component';
import { FormsModule } from "@angular/forms";
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import {PopoverModule} from "ngx-bootstrap/popover";



@NgModule({
  declarations: [SearchInteriorComponent],
  imports: [
    CommonModule,
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    FormsModule
  ],
  exports: [SearchInteriorComponent]
})
export class SearchInteriorModule { }
